import React from "react";
import { Container } from "./styles";

const Input = ({ className, ...props }) => {
  return <Container className={className} {...props} />;
};

export default Input;